import { css } from "@emotion/react";
import StaffInfo from "./StaffInfo";
import { morimotoKozueko } from "./staff";

const Author: React.FC = () => {
  return (
    <>
      <div css={topWhiteSpaceStyle}></div>
      <div css={mainStyle} id="author">
        <div css={containerStyle}>
          <div css={contentsWrapper}>
            <div css={upperTitleWrapperStyle(true)}>
              <div css={borderStyle}></div>
              <div css={titleStyle}>原作著者</div>
              <div css={borderStyle}></div>
            </div>
            <StaffInfo
              staffFileName="morimoto-kozueko.png"
              alt="森本 梢子"
              imgWidth={132}
              txt={morimotoKozueko}
              isTop
              isBottom
            />
            <div css={bottomBorderWrapperStyle}>
              <div css={borderStyle}></div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const primaryColor = "#DD6B74";

const topWhiteSpaceStyle = css`
  width: 100%;
  height: 20px;
  background-color: #fff;
`;

const mainStyle = css`
  width: 100%;
  display: flex;
  justify-content: center;
`;

const containerStyle = css`
  width: 100%;
  max-width: 500px;
  padding: 10px 20px 20px;
  @media (min-width: 768px) {
    padding: 0px 30px 30px;
  }
`;

const contentsWrapper = css`
  padding-bottom: 30px;

  @media (min-width: 768px) {
    margin-top: 5px;
    border: 1px solid ${primaryColor};
  }
`;

const upperTitleWrapperStyle = (isNoPaddingBottom?: boolean) => css`
  display: flex;
  align-items: center;
  padding: 30px 30px 20px;
  ${isNoPaddingBottom && `padding-bottom: 0;`}
`;

const bottomBorderWrapperStyle = css`
  padding: 0 30px;
  display: flex;
  align-items: center;
`;

const borderStyle = css`
  height: 1px;
  background-color: ${primaryColor};
  flex-grow: 1;
`;

const titleStyle = css`
  margin: 0 10px;
  font-size: 12pt;
  font-weight: 500;
`;

export default Author;
